import Vue from 'vue';
import Notify from 'vue2-notify';
import store from './../store';

// https://github.com/websmurf/vue2-notify
Vue.use(Notify, { visibility: 10000, position: 'bottom-left' });

export const eventHub = new Vue({
  store,
});



// WEBPACK FOOTER //
// ./src/utils/eventhub.js